import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Wallet } from "lucide-react";

const FIELDS = [
  { key: "currency", label: "Currency code", type: "text" },
  { key: "storage_per_extra_gb", label: "Extra storage (₹/GB/mo)", type: "number" },
  { key: "integration_price", label: "Integration add-on (₹/mo)", type: "number" },
  { key: "marketplace_addon", label: "Marketplace add-on (₹/mo)", type: "number" },
  { key: "yearly_discount_percent", label: "Yearly discount (%)", type: "number" },
  { key: "tax_percent", label: "Tax / GST (%)", type: "number" },
];

export default function PlatformPricingConfig() {
  const [cfg, setCfg] = useState({});
  const [loading, setLoading] = useState(false);

  const load = async () => { const { data } = await api.get("/platform/config/pricing"); setCfg(data); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      setLoading(true);
      await api.put("/platform/config/pricing", cfg);
      toast.success("Pricing config saved — landing & quotes now reflect changes.");
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="p-8 space-y-6 max-w-3xl" data-testid="admin-platform-pricing">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black flex items-center gap-2"><Wallet className="w-7 h-7 text-primary" /> Pricing Engine</h1>
        <p className="text-muted-foreground">These knobs power every quote on the marketing site. Changes apply instantly.</p>
      </div>
      <div className="surface-card p-6 space-y-4">
        {FIELDS.map((f) => (
          <div key={f.key} className="grid grid-cols-3 gap-3 items-center">
            <Label className="col-span-1">{f.label}</Label>
            <Input
              className="col-span-2"
              type={f.type}
              value={cfg[f.key] ?? ""}
              onChange={(e) => setCfg({ ...cfg, [f.key]: f.type === "number" ? parseFloat(e.target.value || "0") : e.target.value })}
              data-testid={`pricing-${f.key}`}
            />
          </div>
        ))}
        <div className="flex justify-end pt-2">
          <Button onClick={save} disabled={loading} data-testid="pricing-save">Save & publish</Button>
        </div>
      </div>
    </div>
  );
}
